import {isEmpty as isEmptyBase} from 'lodash';

const isEmpty = (value: unknown) => {
    // All values true/false/0/any numbers/NaN are not empty, but isEmpty from lodash returns true for them.
    if (['boolean', 'number'].includes(typeof value)) {
        return false;
    }
    return isEmptyBase(value);
};
export default isEmpty;
